import { Translate } from '~/i18n';
import Container from '~/components/common/container';
import {
   // Balout,
   Diriyah,
   // FormulaE,
   GSA,
   // GWB,
   JeddahSeason,
   // Misk,
   RiyadhMarathon,
   // SuperShowdown,
   SuperCopa,
   TakeshiCastle,
   WWE,
   FE,
   F1,
   FD,
   SaudiCup,
   Doos,
} from '~/svgs/business/events';

/******************************************************************
 *
 *  THIS COMPONENT WAS GENERATED BY NEXTCRAZY-CLI
 *
 ******************************************************************/

const GridCards = () => {
   return (
      <Container className="mt-[58px] lg:mt-[140px] ">
         <div className="mb-[58px] lg:mb-[140px] px-2">
            <div className="text-center font-bold text-[30px] lg:text-[50px] mb-[33px] lg:mb-[77px] rtl:leading-tight">
               <Translate id="business:big events" />
            </div>
            <div className="grid grid-cols-3 xl:grid-cols-6 gap-x-6 gap-y-3 lg:gap-8 justify-items-center items-center">
               <SuperCopa className="p-7 lg:p-0" />
               <SaudiCup className="p-5 lg:p-0" />
               <F1 className="p-5 lg:p-0" />
               <FE className="p-5 lg:p-0" />
               <FD className="p-5 lg:p-0" />
               <JeddahSeason className="p-7 lg:p-0" />
               <Diriyah className="p-5 lg:p-0" />

               <WWE className="p-5 lg:p-0" />

               <GSA className="p-5 lg:p-0" />
               <RiyadhMarathon className="p-5 lg:p-0" />

               <TakeshiCastle className="p-5 lg:p-0" />
               <Doos className="p-5 lg:p-0" />

               {/* <FormulaE className="p-3 lg:p-0" />

               <Balout className="p-5 lg:p-0" />

               <SuperShowdown className="p-5 lg:p-0" />


               <Misk className="p-5 lg:p-0" />

               <GWB className="p-5 lg:p-0" /> */}
            </div>
         </div>
      </Container>
   );
};

export default GridCards;
